
const isProductionServer = process.env.NODE_ENV === 'production'
const isDevelopmentServer = process.env.NODE_ENV === 'development'
const isLocalhostServer = window.location.href.startsWith('http://localhost')
const ServerPost = 9505
const Host = isLocalhostServer ? `http://localhost:${ServerPost}` : (isProductionServer ? 'https://www.syunkaya.com.tw' : (isDevelopmentServer ? 'https://syunkaya.wanwaninfo.com' : `http://localhost:${ServerPost}`))
const AdminHost = isLocalhostServer ? `http://localhost:8080` : (isProductionServer ? 'https://admin.syunkaya.com.tw' : (isDevelopmentServer ? 'https://admin.syunkaya.wanwaninfo.com' : `http://localhost:8080`))
const Config = {
  ADMINURL: AdminHost,
  WEBURL: Host,
  useFakeData: false,
  'firebaseRootFolderName': isProductionServer ? 'www.syunkaya.com.tw' : 'syunkaya.wanwaninfo.com',
  'jwtStorageKey': 'jwt-syunkaya.wanwaninfo.com-djaf23',
  'SaltBefore': 'ajsfdf',
  'SaltAfter': 'afnw4i',
  'languages': ['Tw', 'En', 'Jp'],
  'googleLanguageMap': {
    'Tw': 'zh-Tw',
    'Cn': 'zh-Cn',
    'En': 'en',
    'Jp': 'ja'
  },
  isProductInStockEnabled: true,
  defaultPassword: '1234',
  // fb
  FBClientID: '', // 萬萬正資訊-後台管理系統
  FBScopePagesV9: '', // instagram_basic, pages_show_list required for IG
  FBFansPageID: '', // KPN-Test2
  FBFansPageNumID: '', // KPN-Test2
  // ig
  IGClientID: '', // 萬萬正資訊-後台管理系統
  IGScope: '',
  IGUserID: '',
  // vendor
  isVenderEnabled: false,
  vendorUserAdminLevel: 10,
  // push
  chromeWebPushPublicKey: '',
  // notification
  isNotificationCenterViewEnabled: false, // 右上角通知中心
  isNotificationPollingEnabled: false, // 每6秒polling一次
  isNotificationWebPushEnabled: false// chrome web push
}

Config.API = {
  isProductionServer: isProductionServer,
  isDevelopmentServer: isDevelopmentServer,
  isLocalhostServer: isLocalhostServer,
  Host: Host,
  BPIURL: Host + '/bpi',
  APIURL: Host + '/api',
  FBRedirectUri: '',//window.location.href.startsWith('http://localhost:') ? 'https://6ad77a32dc09.ngrok.io/oauth/fb' : (isProductionServer ? 'https://sample.wanwaninfo.com/oauth/fb' : (isDevelopmentServer ? 'https://dev.sample.wanwaninfo.com/oauth/fb' : 'https://6ad77a32dc09.ngrok.io/oauth/fb')),
  IGRedirectUri: '',// window.location.href.startsWith('http://localhost:') ? 'https://6ad77a32dc09.ngrok.io/oauth/ig' : (isProductionServer ? 'https://sample.wanwaninfo.com/oauth/ig' : (isDevelopmentServer ? 'https://dev.sample.wanwaninfo.com/oauth/ig' : 'https://6ad77a32dc09.ngrok.io/oauth/ig'))
}

// 管理員身份
Config.AdminLevelOptions = [
  { name: '最高管理員', level: 100000 },
  { name: '一般管理員', level: 10000 }
]

export default Config
